/*@flow*/
import createPortal from 'lib/createPortal';
import control from 'lib/leaflet-plugins/Control';
import { useEffect, useState } from 'react';
import type { DeckPropsT } from '../types';

type OptionsT = {
  content: HTMLElement | string,
};

export default (props: DeckPropsT<OptionsT>): any | null => {
  const { owner, options } = props;
  const [element, setElement] = useState();
  const [content, setContent] = useState(null);

  // Add/remove control.
  useEffect(() => {
    const el: Leaflet$Control = control(options);
    owner.addControl(el);
    setElement(() => el);
    return () => {
      owner.removeControl(el);
    };
  }, []);

  // When the options contain 'content', prepare its container.
  useEffect(() => {
    if (!element) return;
    const container = element.getContainer();
    let el, portal;
    switch (typeof options.content) {
      case 'function':
        el = options.content({ owner, element });
        portal = createPortal(el, container);
        setContent(portal);
        break;
      case 'string':
        container.innerHTML = options.content;
        break;
      default:
        break;
    }
  }, [options, element]);

  return content;
};
